(function () {
    angular
        .module('tradersyard')
        .component('tyShowTfaCodesModal', {
            // language=HTML
            template: `
                <div class="modal-header">
                    <h5 class="modal-title">Your 2-factor authentication recovery codes</h5>
                </div>
                <div class="modal-body">
                    <pre class="tfa_recovery_code" ng-repeat="code in codes">{{code}}</pre>
                    <p>Remember to always have a physical copy of your recovery codes.</p>
                </div>
                <div class="modal-body">
                    <h3>What do I do with those codes?</h3>
                    <p>
                        You should write them down or print them, and store them in a safe place.
                    </p>
                    <p>
                        If you lose access to your 2-factor authenticator device, you will be able
                        to recover access to your account by using one of these codes.
                    </p>
                    <p>
                        Each code can be used only once.
                    </p>
                </div>
                <div class="modal-footer">
                    <a class="button" ng-click="$ctrl.close()">Close</a>
                </div>
            `,
            bindings: {
                close: '&',
                resolve: '<',
            },
            controller: 'tyShowTfaCodesModalController',
        })
        .controller('tyShowTfaCodesModalController', ShowTfaCodesModalController);

    ShowTfaCodesModalController.$inject = ['$scope'];

    function ShowTfaCodesModalController($scope) {
        this.$onInit = function () {
            $scope.codes = this.resolve.codes.map((code) => code.join(' ').trim());
        };
    }
})();
